import React, { FC } from 'react';
import { Col, Row, Layout as AntdLayout } from 'antd';
import { USER_KEY } from '../../../authProvider';
import Container from '../container';
import { Menu } from 'components/layout/menu';
import styles from './Header.module.scss';
import { useTranslation } from 'react-i18next';
import { NavigationMenu } from '../navigation-menu';
import { CompanyLogo } from '../../company-logo';
import LanguageSwitcher from '../../language-switcher';
import { UserDropdown } from '../../user-dropdown';
import { useMenuItems } from './useMenuItems';
import AccessibilityButton from '../../AccessibilityToolbar/AccessibilityButton';

export const Header: FC = () => {
    let user: string = localStorage.getItem(USER_KEY) ?? '';
    let { first_name: firstName } = user && JSON.parse(user);
    const { t } = useTranslation();
    const menuItems = useMenuItems();

    return (
        <AntdLayout.Header className={styles.header}>
            <Container max={1580} padX={35} className={styles.headerContainer}>
                <Row className={styles.primary} gutter={[0, 20]}>
                    <Col xs={24}>
                        <Row gutter={[0, 17]} align="middle" wrap>
                            <Col xl={12} lg={12}>
                                <Row gutter={[50, 30]} wrap>
                                    <Col flex="0 0 auto">
                                        <CompanyLogo
                                            href="/"
                                            src="/images/moz.svg"
                                            alt={t(
                                                'pages.login.state_enterprise_state_expert_center_of_the_ministry_of_health_of_ukraine_description'
                                            )}
                                            width={100}
                                            height={48}
                                            className={styles.logo}
                                        />
                                    </Col>
                                    <Col flex={1}>
                                        <NavigationMenu items={menuItems} />
                                    </Col>
                                </Row>
                            </Col>
                            <Col xl={12} lg={12}>
                                <div className={styles.rightSidePanel}>
                                    <div className={styles.content}>
                                        <div className={styles.contentItem}>
                                            <LanguageSwitcher />
                                        </div>
                                        <div className={styles.contentItem}>
                                            <AccessibilityButton />
                                        </div>
                                        <div className={styles.contentItem}>
                                            <div className={styles.username}>
                                                <UserDropdown
                                                    name={firstName}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className={styles.navigation}>
                    <Col flex="0 0 auto">
                        <Menu />
                    </Col>
                </Row>
            </Container>
        </AntdLayout.Header>
    );
};
